import createSimpleComponent from '../createSimpleComponent'

import cls from './dot-color.module.scss'

export default createSimpleComponent({
  displayName: 'DotColor',
  className: cls.wrapper,
  Component: 'span',
})
